<template>
  <div class="facets-type-checkbox">
    <div class="facets-type-checkbox__title">{{ title }}</div>
    <div class="facets-type-checkbox__body">
      <template v-for="option in options[type[0]]">
        <label :key="option.label">
          <input
            ref="checkbox"
            type="checkbox"
            :checked="option.selected"
            :value="option.value"
            @change="emitFacet"
          />
          {{ option.label }}
        </label>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FacetsTypeCheckbox',

  props: {
    type: {
      type: Array,
      required: true,
    },

    name: {
      type: Array,
      required: false,
      default: () => [],
    },

    options: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      selectedItems: [],
    };
  },

  computed: {
    title() {
      return this.name[0] || this.type[0];
    },
  },

  mounted() {
    Object.keys(this.options).forEach((key) => {
      const options = this.options[key];

      options.forEach((option) => {
        if (!option.selected) {
          return;
        }

        let { value } = option;

        if (Array.isArray(value)) {
          value = value.join(',');
        }

        this.selectedItems.push(value);

        this.$emit('selected', {
          value: this.selectedItems,
          key: this.type[0],
        });
      });
    });
  },

  methods: {
    emitFacet({ target }) {
      const { value } = target;

      if (target.checked) {
        this.selectedItems.push(value);
      } else {
        const index = this.selectedItems.indexOf(value);

        if (index > -1) {
          this.selectedItems.splice(index, 1);
        }
      }

      this.$emit('selected', {
        value: this.selectedItems,
        key: this.type[0],
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .facets-type-checkbox {
    &__body {
      label {
        display: block;
        margin-bottom: $global-spacing-unit-half;
      }
    }
  }
</style>
